import { Button, Modal } from "react-bootstrap";
import {
	EmailIcon,
	EmailShareButton,
	LinkedinIcon,
	LinkedinShareButton,
	TwitterIcon,
	TwitterShareButton
} from "react-share";
import PropTypes from "prop-types";

const ShareClassModal = ({
	course,
	show,
	toggleShow
}) => (
	<Modal centered id="share-class-modal" onHide={toggleShow} show={show}>
		<Modal.Header closeButton>
			Share This Class
		</Modal.Header>
		<Modal.Body>
			<EmailShareButton
				body={`I found this class on Life With Cancer that you might like called "${course.title}".\n\n${course.subTitle}`}
				separator="\n\n"
				subject={`Class you might like: ${course.title}`}
				url={window.location.href}
			>
				<EmailIcon />
			</EmailShareButton>
			<LinkedinShareButton url={window.location.href}>
				<LinkedinIcon />
			</LinkedinShareButton>
			<TwitterShareButton url={window.location.href}>
				<TwitterIcon />
			</TwitterShareButton>
		</Modal.Body>
		<Modal.Footer className="py-0">
			<Button onClick={toggleShow} variant="link">Close</Button>
		</Modal.Footer>
	</Modal>
);

ShareClassModal.propTypes = {
	course: PropTypes.shape({
		subTitle: PropTypes.string,
		title: PropTypes.string
	}).isRequired,
	show: PropTypes.bool,
	toggleShow: PropTypes.func
};

ShareClassModal.defaultProps = {
	show: false,
	toggleShow: () => null
};

export default ShareClassModal;
